const getStates = (type = 'full') => {
    return [
        { id: 'AC', name : `states.${type}.ac` },
        { id: 'AL', name : `states.${type}.al` },
        { id: 'AM', name : `states.${type}.am` },
        { id: 'AP', name : `states.${type}.ap` },
        { id: 'BA', name : `states.${type}.ba` },
        { id: 'CE', name : `states.${type}.ce` },
        { id: 'DF', name : `states.${type}.df` },
        { id: 'ES', name : `states.${type}.es` },
        { id: 'GO', name : `states.${type}.go` },
        { id: 'MA', name : `states.${type}.ma` },
        { id: 'MG', name : `states.${type}.mg` },
        { id: 'MS', name : `states.${type}.ms` },
        { id: 'MT', name : `states.${type}.mt` },
        { id: 'PA', name : `states.${type}.pa` },
        { id: 'PB', name : `states.${type}.pb` },
        { id: 'PR', name : `states.${type}.pr` },
        { id: 'PE', name : `states.${type}.pe` },
        { id: 'PI', name : `states.${type}.pi` },
        { id: 'RJ', name : `states.${type}.rj` },
        { id: 'RN', name : `states.${type}.rn` },
        { id: 'RS', name : `states.${type}.rs` },
        { id: 'RO', name : `states.${type}.ro` },
        { id: 'RR', name : `states.${type}.rr` },
        { id: 'SC', name : `states.${type}.sc` },
        { id: 'SP', name : `states.${type}.sp` },
        { id: 'SE', name : `states.${type}.se` },
        { id: 'TO', name : `states.${type}.to` }
    ];
}

export default {

    getStates(){
        return getStates();
    },

    getStateLabel(stateId) {
        return getStates().filter(state => state.id === stateId)[0]?.name;
    }
}